import React, { useState } from "react";
import axios from "axios";
import { navigate } from "gatsby";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Link from "./Link";
import {
  TextInput,
  TextArea,
  Checkbox,
  Select,
  Radio,
  RadioGroup,
  ErrorModalHelper,
} from "./forms/FormikFields";

const ActualForm = ({ thanks, location }) => {
  const [showErrors, setShowErrors] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  const tryit = (e, props) => {
    e.preventDefault(); // Make sure to prevent default submission behavior here

    if (props.dirty === false) {
      // The form has not been touched
      setShowErrors(`The form was not sent, please check all the fields`);
    }
    if (props.dirty === true && !props.isValid) {
      // The form is touched but it is invalid
      setShowErrors(`The form was not sent, please check all the fields`);
    }
    if (props.dirty === true && props.isValid) {
      // The form is touched and it is valid
      setShowErrors(false);
    }
    // We always call submit, because this tries to submit the form and highlights any errors on the form
    props.handleSubmit();
  };

  return (
    <Formik
      validateOnChange={true}
      validateOnBlur={true}
      initialValues={{
        name: "",
        email: "",
        subject: "",
        message: "",
        form_location: "contact page",
        terms: false,
      }}
      validationSchema={Yup.object({
        name: Yup.string().required("Your name is required"),
        email: Yup.string()
          .email("Invalid email address")
          .required("Your email address is required"),
        subject: Yup.string().required("Please enter a subject"),
        message: Yup.string()
          .required("Please enter a message")
          .min(5, "Your message must be at least 5 characters long!"),
        terms: Yup.boolean()
          .required("Please acknowledge you've read the privacy policy")
          .oneOf([true], "Please acknowledge you've read the privacy policy"),
      })}
      onSubmit={async (values, { setSubmitting }) => {
        try {
          const res = await fetch("/.netlify/functions/sendgrid", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(values),
          });

          console.log("Response from sendgrid:", JSON.stringify(res, null, 2));

          if (res.ok) {
            // .ok is true if the response status is 2xx
            navigate(`/${thanks}`);
            //setShowThankYou(true);
          } else {
            throw new Error(`Unexpected response: ${res.statusText}`);
          }
        } catch (err) {
          setSubmitting(false);

          // Check for errors in the response
          console.error(err); // Log for debugging

          let errorMsg =
            "There was an error sending the form. Please try again.";

          // If the error is an HTTP error response, let's check if there's a message in the response
          if (err.response && err.response.data && err.response.data.message) {
            errorMsg = err.response.data.message;
          } else if (err.message) {
            errorMsg = err.message; // For general JS errors
          }

          // Show the error to the user
          setShowErrors(errorMsg);
        }
      }}
    >
      {(props) => (
        <Form onSubmit={props.handleSubmit}>
          {showThankYou ? (
            <p className="text-black bg-success p-6 rounded-lg text-center">
              Your message has been sent
            </p>
          ) : (
            <>
              <TextInput id="name" name="name" type="text" placeholder="Name" />
              <TextInput
                id="email"
                name="email"
                type="email"
                placeholder="Email address"
              />
              <TextInput
                id="subject"
                name="subject"
                type="text"
                placeholder="Subject"
              />
              <TextArea id="message" name="message" placeholder="Message" />
              <Checkbox name="terms" id="terms">
                I have read and agree to the{" "}
                <Link to="/privacy" target="_blank">
                  Privacy Policy
                </Link>
              </Checkbox>

              <ErrorModalHelper
                closeFunction={() => setShowErrors(false)}
                message={showErrors}
              />

              <div className="flex flex-row items-center justify-between gap-6">
                <button
                  className="brand-button"
                  type="submit"
                  onClick={(e) => tryit(e, props)} // Pass `e` to `tryit`
                >
                  <span className="brand-button-text">Submit</span>
                  <span className="material-icons">
                    {props.isSubmitting ? "rotate_right" : "arrow_forward_ios"}
                  </span>
                </button>

                <button
                  button
                  className="underline"
                  onClick={props.handleReset}
                >
                  Cancel
                </button>
              </div>
            </>
          )}
        </Form>
      )}
    </Formik>
  );
};

export default ActualForm;
